window.addEventListener("Angle3DCustomizerLoaded", (event) => {
    const { productHandle, productId, modelId } = event.detail;
  // Add to cart event listener to handle loading state and redirect
  window.addEventListener("Angle3DAddToCart", function(event) {
    console.log('Angle3DAddToCart', JSON.stringify(event.detail));
    // Remove loading state from custom button
    const customButton = document.querySelector('.tda-custom__add');
    if (customButton) {
      customButton.disabled = false;
      customButton.innerHTML = 'Add to Cart';
      customButton.classList.remove('loading');
    }
  
    // Redirect to cart page
    window.location.href = '/cart';
  });

  // Hide Order Type and Quantity Tiers customization options as they are controlled dynamically
  function setupCustomColorOption(content, contentInput, titleText) {
      // hide the original input
      if (contentInput) contentInput.style.display = 'none';
      if (contentInput) contentInput.value = '';

      // create wrapper
    
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-color-picker-wrapper';

      const colorInput = document.createElement('input');
      colorInput.type = 'color';
      colorInput.className = 'custom-color-picker-input';

      const initial = contentInput && contentInput.value ? contentInput.value : '#000000';
      colorInput.value = initial;
      wrapper.style.backgroundColor = initial;

      // create checkbox + label
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.style.marginRight = '8px';

      const checkboxLabel = document.createElement('label');
      checkboxLabel.textContent = ' Use custom color';
      checkboxLabel.style.cursor = 'pointer';
      checkboxLabel.prepend(checkbox);

      // Function to find the corresponding button.tda-accordion
      const findCorrespondingButton = () => {
        // Try to find button that contains the exact title text
        const allButtons = document.querySelectorAll('button.tda-accordion');
        for (let btn of allButtons) {
          // Get text content and check if it includes the title (e.g., "6. Custom Color 1" includes "Custom Color 1")
          const btnText = btn.textContent || btn.innerText;
          if (btnText.includes(titleText)) {
            return btn;
          }
        }
        return null;
      };

      // Function to update the button's color display
      const updateButtonColorDisplay = (color) => {
        const button = findCorrespondingButton();
        if (button) {
          const detailSection = button.querySelector('.selected-option-value-detail-section');
          if (detailSection) {
            if (color && checkbox.checked) {
              detailSection.textContent = color;
              detailSection.style.display = 'inline-block';
              detailSection.style.marginLeft = '8px';
            } else {
              detailSection.textContent = '';
              detailSection.style.display = 'none';
            }
          }
        }
      };

      // function to apply or clear the value
      const applyColorValue = () => {
        if (checkbox.checked) {
          const col = colorInput.value;
          wrapper.style.backgroundColor = col;
          if (contentInput) {
            contentInput.value = col;
            contentInput.dispatchEvent(new Event('input', { bubbles: true }));
            contentInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          // Update button color display
          updateButtonColorDisplay(col);
        } else {
          if (contentInput) {
            contentInput.value = '';
            contentInput.dispatchEvent(new Event('input', { bubbles: true }));
            contentInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          // Clear button color display
          updateButtonColorDisplay(null);
        }
      };

      // event listeners
      colorInput.addEventListener('input', applyColorValue);
      colorInput.addEventListener('change', applyColorValue);
      checkbox.addEventListener('change', () => {
        applyColorValue();
        handlePriceTabsOnCheckbox(checkbox);
        // Update price elements when checkbox is toggled
        // Use longer timeout to ensure all DOM updates from tab clicks and quantity changes complete
        setTimeout(() => {
          // Update quantity display
          const qty = document.querySelector('.tda-customizer-footer-qty');
          if (qty) {
            const qtyInput = qty.querySelector('input.quantity-field');
            if (qtyInput) {
              const qtyNum = document.querySelector('.total-prd-qty-num');
              if (qtyNum) {
                qtyNum.textContent = qtyInput.value;
              }
            }
          }
          updateTieredPricePerItem();
        }, 300);
      });
      // assemble and return the wrapper + controls

      wrapper.appendChild(colorInput);
      return { wrapper, checkboxLabel };
  }
  function handlePriceTabsOnCheckbox(checkbox) {
    // Check ALL custom color checkboxes to see if ANY are checked
    const allCustomColorCheckboxes = [];
    const customColorOptions = document.querySelectorAll('.tda-customizer-customization-option');
    
    customColorOptions.forEach(option => {
      const titleEl = option.querySelector('.tda-customizer-customization-option-title');
      if (titleEl) {
        const titleText = titleEl.textContent.trim();
        if (titleText.includes('Custom') || titleText.includes('Custom')) {
          const checkboxInOption = option.querySelector('.custom-color-control-wrapper input[type="checkbox"]');
          if (checkboxInOption) {
            allCustomColorCheckboxes.push(checkboxInOption);
          }
        }
      }
    });

    // Check if ANY checkbox is checked
    const anyChecked = allCustomColorCheckboxes.some(cb => cb.checked);

    const allTabs = document.querySelectorAll('.product-main__price-tab');
    const overseasTabs = document.querySelectorAll('.product-main__price-tab.product-main__price-tab-overseas');
    const qty = document.querySelector('.tda-customizer-footer-qty');
    const moqNote = document.querySelector('.MOq_Note');
    if (!qty) return;
    const quantityInput = qty.querySelector('input.quantity-field');
    if (!quantityInput) return;

    if (anyChecked) {
      // If ANY checkbox is checked, apply overseas settings
      overseasTabs.forEach(tab => tab.click());
      quantityInput.setAttribute("data-moq", "500");
      quantityInput.setAttribute("value", "500");
      quantityInput.value = "500";
      if(moqNote){
        moqNote.style.display = 'block';
      }
      // Trigger input event to notify other listeners
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      allTabs.forEach(tab => {
        tab.style.pointerEvents = 'none';
      });
    } else {
      // Only if ALL checkboxes are unchecked, revert to default
      quantityInput.setAttribute("data-moq", "100");
      quantityInput.setAttribute("value", "100");
      quantityInput.value = "100";
       if(moqNote){
        moqNote.style.display = 'none';
      }
      // Trigger input event to notify other listeners
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (allTabs.length > 0) {
        allTabs[0].click();
      }

      // re-enable pointer events
      allTabs.forEach(tab => {
        tab.style.pointerEvents = 'auto';
        // if you added a disabled class, remove it
        // tab.classList.remove('disabled‑tab');
      });
    }
  }

  // Main logic
  const customizerOptions = document.querySelectorAll('.tda-customizer-customization-option');
  customizerOptions.forEach(option => {
    const titleEl = option.querySelector('.tda-customizer-customization-option-title');
    const content = option.querySelector('.tda-customizer-customization-option-value-list');
    const contentInput = content ? content.querySelector('input') : null;
    if (!titleEl || !content) return;

    const titleText = titleEl.textContent.trim();
    if (titleText === 'Order Type' || titleText === 'Quantity Tiers') {
      option.style.display = 'none';
      return;
    }

   if (titleText.includes('Custom') ||titleText.includes('Custom')){
      content.style.margin = '0px';

      // avoid re-initializing
      if (content.querySelector('.custom-color-picker-wrapper')) return;

      const { wrapper, checkboxLabel } = setupCustomColorOption(content, contentInput, titleText);
       const ctrlWrapper = document.createElement('div');
  ctrlWrapper.className = 'custom-color-control-wrapper';
  
      ctrlWrapper.appendChild(checkboxLabel);
      ctrlWrapper.appendChild(wrapper);
      content.appendChild(ctrlWrapper);

    }
  });


});

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.product-main__price-tab');
  const tables = document.querySelectorAll('.tiered-pricing-table');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      tabs.forEach(tab => tab.classList.remove('product-main__price-tab-active'));
      tables.forEach(table => table.classList.remove('tiered-pricing-table__active'));
      tab.classList.add('product-main__price-tab-active');
      tables[index].classList.add('tiered-pricing-table__active');
      updateTieredPricePerItem();
      
      // Sync the Order Type option with the selected tab
      setTimeout(() => {
        syncOrderTypeWithTabs();
      }, 100);
    });
  });
});

const setStyleReset = (selector) => {
  const element = document.querySelector(selector);
  if (!element) {
    return false;
  }

  setTimeout(() => {
    element.removeAttribute("style");
  }, 100);

  return true;
};

const addCustomizerReadyClass = () => {
  const wrapper = document.querySelector(".tda-customizer-wrapper");
  if (wrapper) {
    wrapper.classList.add("tda-customizer__ready");
    return true;
  }
  return false;
};

const resetCustomizerStyles = () => {
  const selectors = [
    ".tda-customizer-app-section-container",
    ".tda-app-section-model-viewer-container",
  ];

  selectors.forEach((selector) => setStyleReset(selector));
};

const addToCartCustom = () => {
  const btn = document.querySelector(".tda-customizer-footer-atc-btn");

  btn.classList.remove("tda-customizer-footer-atc-btn");
  btn.classList.add("button");
  btn.classList.add("tda-customizer-footer-atc-btn-custom");
};

// -------------------------------------------------------
// LOGO UPLOAD LABEL
// Must be at global scope so the second Angle3DCustomizerLoaded
// listener can call it.
// -------------------------------------------------------
function setupLogoUploadLabel() {
  const options = document.querySelectorAll('.tda-customizer-customization-option');

  options.forEach(option => {
    const titleEl = option.querySelector('.tda-customizer-customization-option-title');
    if (!titleEl || !titleEl.textContent.trim().includes('Upload Your Logo')) return;

    const img = option.querySelector('img.tda-file-upload-image');
    if (!img) return;

    const panel  = option.closest('.tda-accordion-panel');
    const button = panel ? panel.previousElementSibling : null;
    if (!button) return;

    const detailSpan = button.querySelector('.selected-option-value-detail-section');
    if (!detailSpan) return;

    const updateLabel = () => {
      const src = img.getAttribute('src') || '';
      const isUploaded = src !== '' && src !== '#';

      if (isUploaded) {
        detailSpan.textContent = 'Logo Uploaded';
      } else {
        detailSpan.textContent = '';
      }
    };

    const obs = new MutationObserver(updateLabel);
    obs.observe(img, { attributes: true, attributeFilter: ['src'] });

    // Run once on init in case a logo is already present
    updateLabel();
  });
}

function updateTieredPricePerItem() {
  const qtyInput = document.querySelector(".tda-customizer-footer-qty input.quantity-field");
  if (!qtyInput) return;
  const currentQty = parseInt(qtyInput.value);
  const totalQtyNum = document.querySelector(".total-prd-qty-num");
  if (totalQtyNum) {
    totalQtyNum.textContent = qtyInput.value;
  }

  const isDomesticTabActive = document
    .querySelector(".product-main__price-tab.product-main__price-tab-domestic")
    ?.classList.contains("product-main__price-tab-active");

  const isOverseasTabActive = document
    .querySelector(".product-main__price-tab.product-main__price-tab-overseas")
    ?.classList.contains("product-main__price-tab-active");

  if (!isDomesticTabActive && !isOverseasTabActive) return;

  const quantityBreakpoints = document.querySelectorAll(".tiered-pricing-table-domestic .domestic_table_qty_row td");
  const correspondingPrices = document.querySelectorAll(".tiered-pricing-table-domestic .domestic_table_price_row td");

  let applicablePrice = null;

  quantityBreakpoints.forEach((qtyCell, i) => {
    const minQty = parseInt(qtyCell.getAttribute("quantity").replace(",", ""));
    const nextMinQtyCell = quantityBreakpoints[i + 1];
    const nextMinQty = nextMinQtyCell
      ? parseInt(nextMinQtyCell.getAttribute("quantity").replace(",", ""))
      : Infinity;

    if (currentQty >= minQty && currentQty < nextMinQty) {
      applicablePrice = parseFloat(correspondingPrices[i].getAttribute("price"));
    }
  });

  if (applicablePrice !== null) {
    let addonTotalPrice = 0;

    const panels = document.querySelectorAll(".tda-customizer-customization-options-container div.tda-accordion-panel");

    panels.forEach(panel => {
      const valueList = panel.querySelector("div.tda-customizer-customization-option-value-list");

      // ✅ Add event listeners ONCE per load for ALL panels
      if (valueList && !valueList.dataset.bound) {
        const options = valueList.querySelectorAll(".tda-customizer-customization-option-value");

        options.forEach(option => {
          option.addEventListener("click", () => {
            setTimeout(() => {
              updateTieredPricePerItem(); // 🔁 Recalculate on click
            }, 100);
          });
        });

        valueList.dataset.bound = "true"; // 🛡 Prevent duplicate bindings
      }

      // ✅ Check for selected option and extract price from span
      const selected = panel.querySelector(".tda-customizer-customization-option-value-selected");
      
      if (selected) {
        let optionPrice = 0;
        
        // Look for span inside the selected option
        const priceSpan = selected.querySelector("span");
        
        if (priceSpan) {
          // Extract price from span text (e.g., "+$5.00" or "$5.00")
          const spanText = priceSpan.textContent.trim();
          const priceMatch = spanText.match(/\+?\$?(\d+(?:\.\d+)?)/);
          
          if (priceMatch) {
            optionPrice = parseFloat(priceMatch[1]);
           
          }
        }
        // If no span found, optionPrice remains 0
        addonTotalPrice += optionPrice;
      }
    });

    const basePrice = isOverseasTabActive
      ? applicablePrice * 0.8
      : applicablePrice;

    const finalPrice = (basePrice + addonTotalPrice).toFixed(2);

    const pricePerItem = document.querySelector(".prd-discounted-price-per-item-num");
    if (pricePerItem) {
      pricePerItem.textContent = finalPrice;
    }

    const totalPrice = (parseFloat(finalPrice) * currentQty).toFixed(2);
    const totalPriceNum = document.querySelector(".prd-total-price-num");
    if (totalPriceNum) {
      totalPriceNum.textContent = totalPrice;
    }
  }
}

// Function to sync Order Type options with pricing table tabs
function syncOrderTypeWithTabs() {
  const isDomesticTabActive = document
    .querySelector(".product-main__price-tab.product-main__price-tab-domestic")
    ?.classList.contains("product-main__price-tab-active");
  
  const isOverseasTabActive = document
    .querySelector(".product-main__price-tab.product-main__price-tab-overseas")
    ?.classList.contains("product-main__price-tab-active");

  // Find the Order Type customization option
  const orderTypeOptions = document.querySelectorAll('.tda-customizer-customization-option');
  
  orderTypeOptions.forEach(option => {
    const title = option.querySelector('.tda-customizer-customization-option-title');
    if (title && title.textContent.trim() === 'Order Type') {
      const domesticOption = option.querySelector('.tda-customizer-customization-option-value[id*="5xy3du"], .tda-customizer-customization-option-value .tda-customizer-customization-option-value-title');
      const overseasOption = option.querySelector('.tda-customizer-customization-option-value[id*="uhdfy"], .tda-customizer-customization-option-value .tda-customizer-customization-option-value-title');
      
      // Find all option values in this Order Type section
      const allOptions = option.querySelectorAll('.tda-customizer-customization-option-value');
      
      allOptions.forEach(optionValue => {
        const titleElement = optionValue.querySelector('.tda-customizer-customization-option-value-title');
        if (titleElement) {
          const optionText = titleElement.textContent.trim();
          
          // Check if this option should be selected based on active tab
          if ((isDomesticTabActive && optionText === 'Domestic') || 
              (isOverseasTabActive && optionText === 'Overseas')) {
            
            // Only click if not already selected
            if (!optionValue.classList.contains('tda-customizer-customization-option-value-selected')) {
              optionValue.click();
            }
          }
        }
      });
    }
  });
}

// Function to sync quantity changes with available quantity tier options
function syncQuantityWithTiers() {
  const qtyInput = document.querySelector(".tda-customizer-footer-qty input.quantity-field");
  if (!qtyInput) return;
  
  const currentQty = parseInt(qtyInput.value);
  
  // Determine which pricing table is active to get the correct breakpoints
  const isDomesticActive = document
    .querySelector(".tiered-pricing-table-domestic")
    ?.classList.contains("tiered-pricing-table__active");
  
  const tableSelector = isDomesticActive 
    ? ".tiered-pricing-table-domestic .domestic_table_qty_row td" 
    : ".tiered-pricing-table-overseas .overseas_table_qty_row td";
  
  // Get available quantity breakpoints from the active pricing table
  const quantityBreakpoints = document.querySelectorAll(tableSelector);
  
  let targetTier = null;
  let targetTierText = null;
  
  // Convert breakpoints to array and sort by quantity value
  const breakpointData = [];
  quantityBreakpoints.forEach((qtyCell) => {
    if (qtyCell.hasAttribute("quantity")) {
      const minQty = parseInt(qtyCell.getAttribute("quantity").replace(/,/g, ""));
      const displayText = qtyCell.textContent.trim();
      breakpointData.push({ minQty, displayText, element: qtyCell });
    }
  });
  
  // Sort by quantity ascending
  breakpointData.sort((a, b) => a.minQty - b.minQty);
  
  // Find the appropriate tier based on current quantity
  for (let i = 0; i < breakpointData.length; i++) {
    const current = breakpointData[i];
    const next = breakpointData[i + 1];
    
    if (next) {
      // If current quantity is between this tier and the next tier
      if (currentQty >= current.minQty && currentQty < next.minQty) {
        targetTier = current.minQty.toString();
        targetTierText = current.displayText;
        break;
      }
    } else {
      // This is the highest tier, check if quantity meets minimum
      if (currentQty >= current.minQty) {
        targetTier = current.minQty.toString();
        targetTierText = current.displayText;
        break;
      }
    }
  }
  
  // If no tier found and we have breakpoints, use the first (lowest) tier
  if (!targetTier && breakpointData.length > 0) {
    targetTier = breakpointData[0].minQty.toString();
    targetTierText = breakpointData[0].displayText;
  }
  
  // Find and click the corresponding quantity tier option in the customizer
  if (targetTier && targetTierText) {
    const quantityTierOptions = document.querySelectorAll('.tda-customizer-customization-option');
    
    quantityTierOptions.forEach(option => {
      const title = option.querySelector('.tda-customizer-customization-option-title');
      if (title && title.textContent.trim() === 'Quantity Tiers') {
        const allOptions = option.querySelectorAll('.tda-customizer-customization-option-value');
        
        allOptions.forEach(optionValue => {
          const titleElement = optionValue.querySelector('.tda-customizer-customization-option-value-title');
          if (titleElement) {
            const optionText = titleElement.textContent.trim();
            
            // Match exactly with the display text from the pricing table
            if (optionText === targetTierText) {
              // Only click if not already selected
              if (!optionValue.classList.contains('tda-customizer-customization-option-value-selected')) {
                optionValue.click();
              }
            }
          }
        });
      }
    });
  }
}


const addSyncedCartButton = () => {
  // ── MAX QUANTITY LIMIT (Shopify platform cap) ──────────────────────────
  const MAX_QTY = 1000000;

  const container = document.querySelector(
    ".tda-customizer-controls-container"
  );
  const client_approval_mockup_text = document.querySelector(".client-approval-mockup-text");
  const total_qty_pricing = document.querySelector(".total-qty-pricing-wrap");
  const qty = document.querySelector(".tda-customizer-footer-qty");
  const qtyInput = qty.querySelector("input.quantity-field");
  qtyInput.setAttribute("min", "100");
  qtyInput.setAttribute("max", MAX_QTY); // ── NEW: enforce platform cap
  qtyInput.setAttribute("data-moq", "100");
  qtyInput.setAttribute("value", "100");
  document.querySelector(".total-prd-qty-num").textContent = qtyInput.value;

  // ── NEW: helper to toggle the plus button at the max limit ────────────
  const plusBtn = qty.querySelector(".button-plus");
  const updatePlusBtn = () => {
    const currentVal = parseInt(qtyInput.value);
    if (currentVal >= MAX_QTY) {
      plusBtn.disabled = true;
      plusBtn.setAttribute("aria-disabled", "true");
    } else {
      plusBtn.disabled = false;
      plusBtn.removeAttribute("aria-disabled");
    }
  };
  // ─────────────────────────────────────────────────────────────────────

  qtyInput.addEventListener("input", () => {
    // ── NEW: cap typed value at MAX_QTY immediately ───────────────────
    if (parseInt(qtyInput.value) > MAX_QTY) {
      qtyInput.value = MAX_QTY;
    }
    // ─────────────────────────────────────────────────────────────────
    updateTieredPricePerItem();
    updatePlusBtn(); // ── NEW
    // Sync quantity with tier options
    setTimeout(() => {
      syncQuantityWithTiers();
    }, 100);
  });
  qtyInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      validateQty();
    }
  });
  qtyInput.addEventListener("blur", () => {
    validateQty();
  });
  function validateQty() {
    let current = parseInt(qtyInput.value);
    const moq = parseInt(qtyInput.getAttribute('data-moq'), 10);
    if (isNaN(current) || current < moq) {
      qtyInput.value = moq;
    }
    // ── NEW: also cap at MAX_QTY on validate ─────────────────────────
    if (parseInt(qtyInput.value) > MAX_QTY) {
      qtyInput.value = MAX_QTY;
    }
    // ─────────────────────────────────────────────────────────────────
    document.querySelector(".total-prd-qty-num").textContent = qtyInput.value;
    updateTieredPricePerItem();
    updatePlusBtn(); // ── NEW
    // Sync quantity with tier options after validation
    setTimeout(() => {
      syncQuantityWithTiers();
    }, 100);
  }

  const minusBtn = qty.querySelector(".button-minus");
  minusBtn.addEventListener("click", () => {
    setTimeout(() => {
      const newQty = parseInt(qtyInput.value);
      const moq = parseInt(qtyInput.getAttribute('data-moq'), 10);
      const newVal = newQty - 1;
    if (newVal >= moq) {
      qtyInput.value = newVal;
      updateTieredPricePerItem();
      syncQuantityWithTiers();
    }
    else{
      qtyInput.value = moq;
      qtyInput.setAttribute('data-moq', moq);
      updateTieredPricePerItem();
      syncQuantityWithTiers();
    }
      updateTieredPricePerItem();
      document.querySelector(".total-prd-qty-num").textContent = qtyInput.value;
      updatePlusBtn(); // ── NEW
      // Sync quantity with tier options after minus button click
      syncQuantityWithTiers();
    })
  });

  plusBtn.addEventListener("click", () => {
    setTimeout(() => {
      // ── NEW: prevent going above MAX_QTY ─────────────────────────
      if (parseInt(qtyInput.value) > MAX_QTY) {
        qtyInput.value = MAX_QTY;
      }
      // ─────────────────────────────────────────────────────────────
      updateTieredPricePerItem();
      updatePlusBtn(); // ── NEW
      // Sync quantity with tier options after plus button click
      syncQuantityWithTiers();
    })
  });

  // Run once on load so the button state is correct from the start
  updatePlusBtn(); // ── NEW

  // ------------------------------
  // CUSTOM COLOR CHECKBOX + PICKER WRAPPER
  // ------------------------------

  const newButton = document.createElement("button");
  const qtyAppBefore = document.createElement("div");
  const client_approval_mockup = document.createElement("div");
  const qtyAppAfter = document.createElement("div");
  qtyAppBefore.className = "qty-app__before";
  client_approval_mockup.className = "client-approval-mockup-text-wrap";
  qtyAppAfter.className = "qty-app__after";
  newButton.textContent = "Add to Cart";
  newButton.className = "button tda-custom__add";
  const originalButton = document.querySelector(
    ".tda-customizer-footer-atc-btn-custom"
  );
  const moqNote = document.createElement("div");
  moqNote.className = "MOq_Note";
  moqNote.style.display = "none";
  moqNote.textContent = "Custom Pantone fabrication automatically applies Overseas pricing & timing and a 500 unit MOQ.";

  newButton.addEventListener("click", () => {
    // Add loading state
    newButton.disabled = true;
    newButton.innerHTML = '<span class="loading-spinner"></span> Adding...';
    newButton.classList.add('loading');
    
    originalButton.click();
  });

  const observer = new MutationObserver(() => {
    newButton.disabled = originalButton.disabled;
  });

  observer.observe(originalButton, {
    attributes: true,
    attributeFilter: ["disabled"],
  });

  newButton.disabled = originalButton.disabled;

  qtyAppBefore.appendChild(qty);
  client_approval_mockup.appendChild(client_approval_mockup_text);
  qtyAppAfter.appendChild(total_qty_pricing);
  container.appendChild(qtyAppBefore);
  container.appendChild(qtyAppAfter);
  container.appendChild(newButton);
  container.appendChild(client_approval_mockup);
  container.insertBefore(moqNote, newButton);
  updateTieredPricePerItem();
};


const addCustomElement = () => {
  const targetContainer = document.querySelector(
    ".tda-product-details-top-container"
  );
  const targetContainerMobile1024 = document.querySelector(
    ".tda-customizer-customization-options-container"
  );

  const elements = [
    document.querySelector(".product-sample"),
    document.querySelector(".product-inquiry"),
    document.querySelector(".product-main__price-table"),
    document.querySelector(".product-main__code"),
  ];
  const moveElements = () => {
    const container =
      window.innerWidth <= 1024 ? targetContainerMobile1024 : targetContainer;
    const sample_form = document.querySelector(".product-sample");
    const inquiry_form = document.querySelector(".product-inquiry");

    elements.forEach((element) => {
      if (element && container) {
        container.after(element);
      }
    });
  };

  moveElements();
  window.addEventListener("resize", moveElements);
  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(() => {
      moveElements();
    });
    resizeObserver.observe(document.body);
  }
};

addCustomElement();

window.addEventListener("Angle3DCustomizerLoaded", (event) => {
  //.tda-customizer-controls-container
  //.tda-customizer-footer

  addCustomizerReadyClass();
  resetCustomizerStyles();
  addToCartCustom();
  addSyncedCartButton();
  addCustomElement();
  setupLogoUploadLabel(); // ── show "Uploaded" label next to accordion title
});

document.addEventListener("DOMContentLoaded", () => {
  const modals = [
    {
      modal: document.getElementById("inquiry-form__dialog"),
      openBtn: document.getElementById("inquiry-form__dialog-open"),
      closeBtn: document.getElementById("inquiry-form__dialog-close"),
    },
    {
      modal: document.getElementById("sample-form__dialog"),
      openBtn: document.getElementById("sample-form__dialog-open"),
      closeBtn: document.getElementById("sample-form__dialog-close"),
    },
  ];

  modals.forEach(({ modal, openBtn, closeBtn }) => {
    if (modal && openBtn && closeBtn) {
      openBtn.addEventListener("click", () => modal.showModal());
      closeBtn.addEventListener("click", () => modal.close());
      modal.addEventListener("keydown", (e) => {
        if (e.key === "Escape") modal.close();
      });
    }
  });
});